"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomHeaders = exports.getTLSProps = exports.getBasicAuthProps = exports.getOnAuthMethodSelectHandler = exports.getSelectedMethod = exports.convertLegacyAuthProps = void 0;
const types_1 = require("./types");
const headerNamePrefix = 'httpHeaderName';
const headerValuePrefix = 'httpHeaderValue';
function convertLegacyAuthProps({ config, onChange, }) {
    const props = {
        selectedMethod: getSelectedMethod(config),
        onAuthMethodSelect: getOnAuthMethodSelectHandler(config, onChange),
        basicAuth: getBasicAuthProps(config, onChange),
        TLS: getTLSProps(config, onChange),
        customHeaders: getCustomHeaders(config, onChange),
        readOnly: config.readOnly,
    };
    return props;
}
exports.convertLegacyAuthProps = convertLegacyAuthProps;
function getSelectedMethod(config) {
    if (config.basicAuth) {
        return types_1.AuthMethod.BasicAuth;
    }
    if (config.withCredentials) {
        return types_1.AuthMethod.CrossSiteCredentials;
    }
    if (config.jsonData.oauthPassThru) {
        return types_1.AuthMethod.OAuthForward;
    }
    return types_1.AuthMethod.NoAuth;
}
exports.getSelectedMethod = getSelectedMethod;
function getOnAuthMethodSelectHandler(config, onChange) {
    return (method) => {
        onChange(Object.assign(Object.assign({}, config), { basicAuth: method === types_1.AuthMethod.BasicAuth, withCredentials: method === types_1.AuthMethod.CrossSiteCredentials, jsonData: Object.assign(Object.assign({}, config.jsonData), { oauthPassThru: method === types_1.AuthMethod.OAuthForward }) }));
    };
}
exports.getOnAuthMethodSelectHandler = getOnAuthMethodSelectHandler;
function getBasicAuthProps(config, onChange) {
    return {
        user: config.basicAuthUser,
        passwordConfigured: config.secureJsonFields.basicAuthPassword,
        onUserChange: (user) => onChange(Object.assign(Object.assign({}, config), { basicAuthUser: user })),
        onPasswordChange: (password) => onChange(Object.assign(Object.assign({}, config), { secureJsonData: Object.assign(Object.assign({}, config.secureJsonData), { basicAuthPassword: password }) })),
        onPasswordReset: () => onChange(Object.assign(Object.assign({}, config), { secureJsonData: Object.assign(Object.assign({}, config.secureJsonData), { basicAuthPassword: '' }), secureJsonFields: Object.assign(Object.assign({}, config.secureJsonFields), { basicAuthPassword: false }) })),
    };
}
exports.getBasicAuthProps = getBasicAuthProps;
function getTLSProps(config, onChange) {
    var _a, _b, _c;
    return {
        selfSignedCertificate: {
            enabled: Boolean(config.jsonData.tlsAuthWithCACert),
            certificateConfigured: !!((_a = config.secureJsonFields) === null || _a === void 0 ? void 0 : _a.tlsCACert),
            onToggle: (enabled) => enabled
                ? onChange(Object.assign(Object.assign({}, config), { jsonData: Object.assign(Object.assign({}, config.jsonData), { tlsAuthWithCACert: enabled }) }))
                : onChange(Object.assign(Object.assign({}, config), { jsonData: Object.assign(Object.assign({}, config.jsonData), { tlsAuthWithCACert: enabled }), secureJsonData: Object.assign(Object.assign({}, config.secureJsonData), { tlsCACert: '' }), secureJsonFields: Object.assign(Object.assign({}, config.secureJsonFields), { tlsCACert: false }) })),
            onCertificateChange: (certificate) => onChange(Object.assign(Object.assign({}, config), { secureJsonData: Object.assign(Object.assign({}, config.secureJsonData), { tlsCACert: certificate }) })),
            onCertificateReset: () => onChange(Object.assign(Object.assign({}, config), { secureJsonData: Object.assign(Object.assign({}, config.secureJsonData), { tlsCACert: '' }), secureJsonFields: Object.assign(Object.assign({}, config.secureJsonFields), { tlsCACert: false }) })),
        },
        TLSClientAuth: {
            enabled: config.jsonData.tlsAuth,
            serverName: config.jsonData.serverName,
            clientCertificateConfigured: !!((_b = config.secureJsonFields) === null || _b === void 0 ? void 0 : _b.tlsClientCert),
            clientKeyConfigured: !!((_c = config.secureJsonFields) === null || _c === void 0 ? void 0 : _c.tlsClientKey),
            onToggle: (enabled) => enabled
                ? onChange(Object.assign(Object.assign({}, config), { jsonData: Object.assign(Object.assign({}, config.jsonData), { tlsAuth: enabled }) }))
                : onChange(Object.assign(Object.assign({}, config), { jsonData: Object.assign(Object.assign({}, config.jsonData), { tlsAuth: enabled, serverName: '' }), secureJsonData: Object.assign(Object.assign({}, config.secureJsonData), { tlsClientCert: '', tlsClientKey: '' }), secureJsonFields: Object.assign(Object.assign({}, config.secureJsonFields), { tlsClientCert: false, tlsClientKey: false }) })),
            onServerNameChange: (serverName) => onChange(Object.assign(Object.assign({}, config), { jsonData: Object.assign(Object.assign({}, config.jsonData), { serverName }) })),
            onClientCertificateChange: (clientCertificate) => onChange(Object.assign(Object.assign({}, config), { secureJsonData: Object.assign(Object.assign({}, config.secureJsonData), { tlsClientCert: clientCertificate }) })),
            onClientCertificateReset: () => onChange(Object.assign(Object.assign({}, config), { secureJsonData: Object.assign(Object.assign({}, config.secureJsonData), { tlsClientCert: '' }), secureJsonFields: Object.assign(Object.assign({}, config.secureJsonFields), { tlsClientCert: false }) })),
            onClientKeyChange: (clientKey) => onChange(Object.assign(Object.assign({}, config), { secureJsonData: Object.assign(Object.assign({}, config.secureJsonData), { tlsClientKey: clientKey }) })),
            onClientKeyReset: () => onChange(Object.assign(Object.assign({}, config), { secureJsonData: Object.assign(Object.assign({}, config.secureJsonData), { tlsClientKey: '' }), secureJsonFields: Object.assign(Object.assign({}, config.secureJsonFields), { tlsClientKey: false }) })),
        },
        skipTLSVerification: {
            enabled: config.jsonData.tlsSkipVerify,
            onToggle: (enabled) => onChange(Object.assign(Object.assign({}, config), { jsonData: Object.assign(Object.assign({}, config.jsonData), { tlsSkipVerify: enabled }) })),
        },
    };
}
exports.getTLSProps = getTLSProps;
function getCustomHeaders(config, onChange) {
    const headers = Object.keys(config.jsonData)
        .filter((key) => key.startsWith(headerNamePrefix))
        .sort()
        .map((key) => {
        var _a;
        const index = key.slice(headerNamePrefix.length);
        return {
            name: config.jsonData[key],
            configured: (_a = config.secureJsonFields[`${headerValuePrefix}${index}`]) !== null && _a !== void 0 ? _a : false,
        };
    });
    return {
        headers,
        onChange: (headers) => {
            const newJsonData = Object.fromEntries(Object.entries(config.jsonData).filter(([key]) => !key.startsWith(headerNamePrefix)));
            const newSecureJsonData = Object.fromEntries(Object.entries(config.secureJsonData || {}).filter(([key]) => !key.startsWith(headerValuePrefix)));
            const newSecureJsonFields = Object.fromEntries(Object.entries(config.secureJsonFields).filter(([key]) => !key.startsWith(headerValuePrefix)));
            headers.forEach((header, index) => {
                newJsonData[`${headerNamePrefix}${index + 1}`] = header.name;
                if (header.configured) {
                    newSecureJsonFields[`${headerValuePrefix}${index + 1}`] = true;
                }
                else {
                    newSecureJsonData[`${headerValuePrefix}${index + 1}`] = header.value;
                }
            });
            onChange(Object.assign(Object.assign({}, config), { jsonData: newJsonData, secureJsonData: newSecureJsonData, secureJsonFields: newSecureJsonFields }));
        },
    };
}
exports.getCustomHeaders = getCustomHeaders;
//# sourceMappingURL=utils.js.map